<template>
  <div>
    <vue-editor
      :id="id"
      ref="editor"
      v-model="message"
      :editor-options="editorSettings"
      :editor-toolbar="customToolbar"
    />
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import Quill from 'quill';
import { ImageDrop } from 'quill-image-drop-module';
import ImageResize from 'quill-image-resize-module';

Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);

export default {
  name: 'CustomVueEditor',
  components: {
    VueEditor,
  },
  props: {
    id: {
      type: String,
      default: () => 'vue-editor-id',
    },
    value: {
      type: String,
      default: () => '',
    },
  },
  data: function() {
    return {
      message: this.value,
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {},
        },
      },
    };
  },
  watch: {
    message: {
      immediate: true,
      handler(val) {
        this.$emit('input', val);
      },
    },
    value: {
      immediate: true,
      handler(val) {
        this.message = val;
      },
    },
  },
  mounted() {
    const Editor = this.$refs.editor;
    const $quillContainer = Editor.$refs.quillContainer;

    $quillContainer.onclick = () => {
      this.message = document.querySelector('.ql-editor').innerHTML;
    };
  },
  computed: {
    customToolbar() {
      return [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        ['blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ['image'],
        ['clean'], // remove formatting button
      ];
    },
  },
};
</script>
